import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const services = [
    'Mortgage Refinance',
    'Pre-underwriting AI',
    'Debt Settlement',
    'Inbound Calls',
    'Health Insurance',
    'Home Security'
  ];

  const quickLinks = [
    { label: 'Career', path: '/about' },
    { label: 'Blog', path: '/blog' },
    { label: 'Contact', path: '/contact' }
  ];

  const industries = [
    'Mortgage Refinance',
    'Debt Consolidation',
    'Home Security',
    'Financial Services',
    'Insurance',
    'B2V Software'
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2040%2040%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.05%22%3E%3Cpath%20d%3D%22M20%2020c0-5.5-4.5-10-10-10s-10%204.5-10%2010%204.5%2010%2010%2010%2010-4.5%2010-10zm10%200c0-5.5-4.5-10-10-10s-10%204.5-10%2010%204.5%2010%2010%2010%2010-4.5%2010-10z%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/90f9aac22cdad51829432cf34fb4cd7d/b7b6dfa86f5fb9b0b93a19a7e790014c.png"
                alt="Halcom Analytics"
                className="h-16 w-auto mr-4"
              />
            </div>
            <p className="text-gray-300 mb-8 leading-relaxed text-lg">
              Leading international lead generation firm specializing in SEO, SEM, digital advertising, and AI-powered solutions for mortgage, debt, and security industries.
            </p>
            <div className="flex space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full cursor-pointer hover:bg-blue-600 transition-all transform hover:scale-110">
                <i className="ri-linkedin-fill text-white text-xl"></i>
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full cursor-pointer hover:bg-blue-600 transition-all transform hover:scale-110">
                <i className="ri-twitter-x-fill text-white text-xl"></i>
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full cursor-pointer hover:bg-blue-600 transition-all transform hover:scale-110">
                <i className="ri-facebook-fill text-white text-xl"></i>
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full cursor-pointer hover:bg-blue-600 transition-all transform hover:scale-110">
                <i className="ri-instagram-fill text-white text-xl"></i>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-blue-300">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-gray-300 hover:text-white transition-colors cursor-pointer hover:translate-x-1 transform inline-block">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-purple-300">Industries</h4>
            <ul className="space-y-3">
              {industries.map((industry) => (
                <li key={industry}>
                  <span className="text-gray-300 hover:text-white transition-colors cursor-pointer hover:translate-x-1 transform inline-block">
                    {industry}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links & Contact */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-green-300">Quick Links</h4>
            <ul className="space-y-3 mb-8">
              {quickLinks.map((link) => (
                <li key={link.path} className="relative">
                  {link.label === 'Career' ? (
                    <div className="flex items-center">
                      <button
                        onClick={() => navigate(link.path)}
                        className="text-gray-300 hover:text-white transition-colors cursor-pointer hover:translate-x-1 transform inline-block"
                      >
                        {link.label}
                      </button>
                      <div className="ml-6">
                        <div className="relative">
                          <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg animate-pulse">
                            Apply Now
                          </div>
                          <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-red-500 rounded-full animate-ping opacity-30"></div>
                          <div className="absolute inset-0 bg-gradient-to-r from-orange-400 to-red-400 rounded-full animate-ping opacity-20 animation-delay-500"></div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => navigate(link.path)}
                      className="text-gray-300 hover:text-white transition-colors cursor-pointer hover:translate-x-1 transform inline-block"
                    >
                      {link.label}
                    </button>
                  )}
                </li>
              ))}
              <li>
                <div className="flex items-center group mt-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-600/20 rounded-lg mr-3 group-hover:bg-orange-600 transition-colors">
                    <i className="ri-briefcase-line text-orange-400 group-hover:text-white"></i>
                  </div>
                  <span className="text-gray-300 text-sm">hr@halcomanalytics.com</span>
                </div>
              </li>
            </ul>
            
            <div className="space-y-4">
              <div className="flex items-center group">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-600/20 rounded-lg mr-3 group-hover:bg-blue-600 transition-colors">
                  <i className="ri-mail-line text-blue-400 group-hover:text-white"></i>
                </div>
                <span className="text-gray-300 text-sm">info@halcomanalytics.com</span>
              </div>
              <div className="flex items-center group">
                <div className="w-8 h-8 flex items-center justify-center bg-purple-600/20 rounded-lg mr-3 group-hover:bg-purple-600 transition-colors">
                  <i className="ri-phone-line text-purple-400 group-hover:text-white"></i>
                </div>
                <a href="tel:+910120418794" className="text-gray-300 text-sm hover:text-white transition-colors">+91 0120 418 7944</a>
              </div>
              <div className="flex items-start group">
                <div className="w-8 h-8 flex items-center justify-center bg-green-600/20 rounded-lg mr-3 group-hover:bg-green-600 transition-colors mt-1">
                  <i className="ri-map-pin-line text-green-400 group-hover:text-white"></i>
                </div>
                <div className="text-gray-300 text-sm">
                  <div className="font-semibold text-white mb-1">Head Office:</div>
                  <div>Suite 304, H 159, VDS, Sector 63, Noida, 201301</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-10 md:mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2025 Halcom Analytics. All rights reserved. Empowering businesses worldwide with premium lead generation.
          </p>
          <div className="flex items-center space-x-6">
            <span className="text-gray-400 text-sm hover:text-white cursor-pointer transition-colors">Privacy Policy</span>
            <span className="text-gray-400 text-sm hover:text-white cursor-pointer transition-colors">Terms of Service</span>
          </div>
        </div>
      </div>

      <style jsx>{`
        .animation-delay-500 {
          animation-delay: 0.5s;
        }
      `}</style>
    </footer>
  );
}
